/**
 * If a slide has a 'title', add the title to a span so we can show it on top of the image
 * To set the title color we use a code in the image title:
 *     - it should be whit if title starts with "W:"
 *     - it should be black if title starts with "B:"
 *
 * @param slider
 */
export function initSliderImageTitles(slider) {
  const slides = slider.querySelectorAll('.glider-slide');
  if (!slides) return;

  slides.forEach((slide) => {
    const slideImage = slide.tagName === 'IMG' ? slide : slide.querySelector('img');
    if (!slideImage) return;

    const slideTitle = slideImage.getAttribute('title');
    if (!slideTitle) return;

    const titleIsBlack = slideTitle.startsWith('B:');
    const cleanTitleText = getCleanTitleText(slideTitle);
    const titleSpanElement = createSpanElement(titleIsBlack, cleanTitleText)
    slide.appendChild(titleSpanElement);
  });
}

/**
 * Clean the slideTitle
 * We need to remove the "B:" and "W:" we use to set the title's color
 *
 * @param slideTitle
 * @returns {*}
 */
function getCleanTitleText(slideTitle) {
  if (slideTitle.startsWith('W:') || slideTitle.startsWith('B:')) {
    return slideTitle.substring(2).trim();
  }
  return slideTitle.trim();
}

/**
 * Create a <span> with the correct text and classes
 *
 * @param titleIsBlack
 * @param cleanTitleText
 * @returns {HTMLSpanElement}
 */
function createSpanElement(titleIsBlack, cleanTitleText) {
  const spanElement = document.createElement('span');
  spanElement.textContent = cleanTitleText;
  spanElement.classList = `slider__title`;
  if (titleIsBlack) {
    spanElement.classList.add('slider__title--black');
  }
  return spanElement;
}
